import { gql } from '@apollo/client';

export const CREATE_GENERATION_TASK = gql`
  mutation CreateGenerationTask($input: GenerationTaskInput!) {
    createGenerationTask(input: $input) {
      id
      status
      planId
      input
      output
      createdAt
      updatedAt
    }
  }
`;

export const SAVE_RESULT_TO_PLAN = gql`
  mutation SaveResultToPlan($planId: ID!, $taskId: ID!) {
    saveResultToPlan(planId: $planId, taskId: $taskId)
  }
`;

export const RETRY_GENERATION_TASK = gql`
  mutation RetryGenerationTask($taskId: ID!, $planId: ID!) {
    retryGenerationTask(taskId: $taskId, planId: $planId) {
      id
      status
      planId
      input
      output
      createdAt
      updatedAt
    }
  }
`;
